export function stripHtmlTags(value: string): string {
  return value.replace(/<[^>]+>/g, '').trim();
}

export function normalizeMarkdownTableCellText(rawText: string): string {
  return stripHtmlTags(rawText).replace(/\s+/g, ' ').trim();
}

/** Valori finanziari negativi nelle tabelle chat (forecast, analytics, ecc.). */
export function isNegativeMarkdownTableCell(rawText: string): boolean {
  const text = normalizeMarkdownTableCellText(rawText);
  if (!text) return false;

  // Formato contabile: (18.927,48€)
  if (/^\([\d.\s,]+€\)$/i.test(text)) return true;

  // Minus italiano: -18.927,48€
  if (/^-\s*[\d.]+\,\d{2}\s*€$/i.test(text)) return true;

  // Minus con € prefisso: -€18.927,48
  if (/^-\s*€\s*[\d.,]+$/i.test(text)) return true;

  return false;
}
